import React from "react";

export default function InactivePlan() {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <h1 className="text-lg text-red-400">
        Esta oferta não está mais disponível para compra.
      </h1>
    </div>
  );
}
